import { h } from 'vue'
import type { SelectOption, SelectRenderLabel, SelectRenderTag } from 'naive-ui'

export interface WarehouseSelectOption extends Omit<SelectOption, 'label' | 'value'> {
  label: string
  value: number
  warehouseName: string
  warehouseCode: string
  dataTest?: string
}

interface WarehouseOptionSource {
  id: number
  warehouseName?: string | null
  warehouseCode?: string | null
}

export function createWarehouseSelectOption(item: WarehouseOptionSource): WarehouseSelectOption {
  const warehouseName = String(item.warehouseName || '').trim()
  const warehouseCode = String(item.warehouseCode || '').trim()
  return {
    label: [warehouseName, warehouseCode].filter(Boolean).join(' ') || '-',
    value: item.id,
    warehouseName,
    warehouseCode,
  }
}

export function createWarehouseSelectOptions(
  items: WarehouseOptionSource[],
): WarehouseSelectOption[] {
  return items.map(createWarehouseSelectOption)
}

export const renderWarehouseSelectLabel: SelectRenderLabel = (option) => {
  const warehouse = option as WarehouseSelectOption
  const warehouseName = warehouse.warehouseName || String(warehouse.label || '-').trim()
  return h(
    'div',
    {
      class: 'flex min-w-0 flex-col justify-center py-1',
      'data-test': warehouse.dataTest,
    },
    [
      h(
        'span',
        { class: 'truncate text-sm font-medium text-text-heading' },
        warehouseName || '-',
      ),
      h(
        'span',
        { class: 'truncate text-xs text-text-secondary' },
        `编码:${warehouse.warehouseCode || '-'}`,
      ),
    ],
  )
}

export const renderWarehouseSelectTag: SelectRenderTag = ({ option }) => {
  const warehouse = option as WarehouseSelectOption
  return h(
    'span',
    { class: 'block truncate text-sm text-text-heading' },
    warehouse.warehouseName || String(warehouse.label || '-'),
  )
}

export const warehouseSelectMenuProps = { class: 'warehouse-select-menu' }
